import * as Yup from 'yup';
import React, { useEffect, useState } from 'react'
import 'react-multi-carousel/lib/styles.css'
import 'bootstrap/dist/css/bootstrap.css'
import './hotels.css'
import Footer from '../common/footer/Footer'
import Header from '../common/header/Header'
import { Button, Stack, Box, Modal, Menu, MenuItem, } from '@mui/material';
import { FormProvider, RHFTextField } from '../hook-form';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Carousel from 'react-multi-carousel'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs'
import { Link, useNavigate, useParams } from "react-router-dom";
import { getHotelById, getHotels, hotelBooking } from '../../api/hotel'
import { myProfile } from '../../api/package';
import { ToastContainer, toast } from 'react-toastify';
import { getImageUrl } from '../../utils/imageUrl';
// -------------------------------------------------

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: '25px',
};

const destination = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 1,
    slidesToSlide: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
    slidesToSlide: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
}

const similar = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 4,
    slidesToSlide: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    slidesToSlide: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
}

const HotelDetail = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openB = Boolean(anchorEl);
  const token = localStorage.getItem('token')
  const notify = (message) => toast(message);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseB = () => {
    setAnchorEl(null);
  };
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    if (token) {
      setOpen(true)
    } else {
      navigate('/login')
    }
  };
  const handleClose = () => setOpen(false);
  const params = useParams()
  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };
  const navigate = useNavigate()
  const [hotel, setHotel] = useState('')

  const hotelId = async () => {
    const resp = await getHotelById(params?.id)
    console.log(resp)
    setHotel(resp?.data)
  }
  useEffect(() => {
    hotelId()
  }, [])
  const tomorrow = dayjs()

  const [hotels, setHotels] = useState([])
  const getHotel = async () => {
    const resp = await getHotels()
    setHotels(resp?.data)
  }
  useEffect(() => {
    getHotel()
  }, [])

  const [profile, setProfile] = useState('')

  const getProfileData = async () => {
    const resp = await myProfile()
    setProfile(resp.data)
    setValue('name', resp.data.name)
    setValue('email', resp.data.email)
    setValue('mobile', resp.data.mobile)
  }

  useEffect(() => {
    if (token) {
      getProfileData()
    }

  }, [])


  const hotelDetails = JSON.parse(localStorage.getItem('hotelDetails')) || []
  console.log(hotelDetails)
  const LoginSchema = Yup.object().shape({
    name: Yup.string().required('Name is Required'),
    mobile: Yup.string().matches(/^\d{10}$/, 'must be 10 numbers').required('Mobile is required'),
    email: Yup.string().email().matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      , 'must be valid email').required('Email is required'),

    adultCount: Yup.number().required('Adult Count is required'),
    childCount: Yup.number().required('Child Count is required'),

    roomCount: Yup.number().required('Room Count is required'),
    checkIn: Yup.string().required('Check in is Required'),
    checkOut: Yup.string().required('Check out is Required'),

  });

  const defaultValues = {
    name: '',
    email: '',
    mobile: '',
    hotel: params.id || '',
    checkIn: '',
    checkOut: '',
    roomCount: 0,

    adultCount: 0,
    childCount: 0
  };

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });

  const {
    watch,
    setValue,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const values = watch();
  const [adult, setAdult] = useState(hotelDetails?.adultCount !== undefined ? hotelDetails?.adultCount : 0)

  const [child, setChild] = useState(hotelDetails?.childCount !== undefined ? hotelDetails?.childCount : 0)


  const [room, setRoom] = useState(hotelDetails?.roomCount !== undefined ? hotelDetails?.roomCount : 0)
  console.log(child)

  useEffect(() => {
    if (adult) {
      setValue('adultCount', adult)
    } else if (adult === 0) {
      setValue('adultCount', 0)
    }
  }, [adult])


  useEffect(() => {
    if (child) {
      setValue('childCount', child)
    } else if (child === 0) {
      setValue('childCount', 0)
    }
  }, [child])


  useEffect(() => {
    if (room) {
      setValue('roomCount', room)
    } else if (room === 0) {
      setValue('roomCount', 0)
    }
  }, [room])
  useEffect(() => {
    if (hotelDetails !== undefined) {
      setValue('checkIn', dayjs(hotelDetails.checkIn))
      setValue('checkOut', dayjs(hotelDetails.checkOut))

      // setRoom(hotelDetails.roomCount)

      // setChild(hotelDetails.childCount)

      // setAdult(hotelDetails.adultCount)

      // setInfant(hotelDetails.guestCount)

    }
  }, [])
  const onSubmit = async () => {
    if (values.name === '') {
      notify('name is required')
    } else if (values.email === '') {
      notify('email is required')
    } else if (values.mobile === '' || values.mobile.toString().length !== 10) {
      notify('valid mobile number is required')
    } else if (values.adultCount === 0) {
      notify('adult count is required')
    } else if (values.checkIn === '') {
      notify('check in is required')
    } else if (values.checkOut === 0) {
      notify('check out is required')
    } else if (values.roomCount === 0) {
      notify('room count is required')
    }

    else if (values.email.match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )) {
      if (token) {
        const resp = await hotelBooking(values)
        if (resp.code === 201) {
          notify(resp.message)
          handleClose()
          localStorage.removeItem('hotelDetails')
          setTimeout(() => {
            navigate('/hotels')
          }, 2000);

        }
      }
    } else {
      notify('Please fill the email carefully')
    }
  };
  console.log(hotel?.amenities)
  const groupedAmenities = hotel?.amenities?.reduce((acc, amenity) => {
    const category = amenity.category;
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(amenity);
    return acc;
  }, {});

  const theObj = { __html: hotel?.description };
  console.log(values)
  return (
    <>
      <Header />
      <section className='py-5'>
        <div className='container'>
          {/* <Box
            sx={{
              backgroundColor: '#f5f5f6',
              padding: '15px 20px',
              borderRadius: '15px',
            }}
          >
            <div className='row'>
              <div className='col-md-6 col-lg-3'>
                <label className="mb-1">Location</label>
                <Autocomplete
                  sx={{ margin: '6px 0 0 0' }}
                  disablePortal
                  id="combo-box-demo"
                  options={top100Films}
                  renderInput={(params) => <TextField {...params} placeholder="Select Location" />}
                />
              </div>
              <div className='col-md-6 col-lg-3 daeSection'>
                <label className="mb-1">Check in - out</label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={['DatePicker']}>
                    <DatePicker placeholder="Select Date" label="Check in - out" />
                  </DemoContainer>
                </LocalizationProvider>
              </div>
              <div className='col-md-6 col-lg-2'>
                <label className="mb-1">Guests</label>
                <Autocomplete
                  sx={{ margin: '6px 0 0 0' }}
                  disablePortal
                  id="combo-box-demo"
                  options={top100Films}
                  renderInput={(params) => <TextField {...params} placeholder="Guests" />}
                />
              </div>
              <div className='col-md-6 col-lg-2'>
                <label className="mb-1">Rooms</label>
                <Autocomplete
                  sx={{ margin: '6px 0 0 0' }}
                  disablePortal
                  id="combo-box-demo"
                  options={top100Films}
                  renderInput={(params) => <TextField {...params} placeholder="Rooms" />}
                />
              </div>
              <div className='col-md-6 col-lg-2'>
                <a className="btn btn-lg btn-primary w-100 mb-0" href="#" style={{ margin: '40px 0 0 0' }}>
                  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="fa-fw" style={{ margin: '0 5px 0 0' }}>
                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                  </svg>
                  Search
                </a>
              </div>
            </div>
          </Box> */}
          <div className='row p-3'>
            <div className='titleDetail'>
              <h3 className='detailHeading'>{hotel.name}</h3>
              <p className="fw-bold mb-0 p-0">
                <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="me-1">
                  <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10"></path>
                  <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6"></path>
                </svg>{hotel.address} ,  {hotel.city}
              </p>
            </div>
          </div>
          <div className='row p-1'>
            <div className='col-md-8 col-xl-8'>
              <Carousel
                className='hotelsGallaryImg'
                responsive={destination}
                infinite={true}
                autoPlay={true}
                autoPlaySpeed={2000}
              >
                {hotel?.images?.length > 0 ? hotel?.images?.map((items, index) => (
                  <Box key={index} className="hotelGallery">
                    <img src={getImageUrl(items)} alt='temp' />
                  </Box>
                )) : <Box className="hotelGallery">
                  <img src='' alt='temp' />
                </Box>}

              </Carousel>
              <div className='hotelDe'>
                <h3>About This Hotel</h3>
                <div dangerouslySetInnerHTML={theObj} />
                {/* <h5 className="py-2">Advantages</h5>
                <ul className="list-group list-group-borderless mb-0">
                  <li className="list-group-item h6 d-flex mb-0">
                    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="text-success me-2">
                      <path d="M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01zm.287 5.984-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708.708"></path>
                    </svg>
                    Every hotel staff to have Proper PPT kit for COVID-19
                  </li>
                  <li className="list-group-item h6 d-flex mb-0">
                    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="text-success me-2">
                      <path d="M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01zm.287 5.984-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708.708"></path>
                    </svg>
                    Every staff member wears face masks and gloves at all service times.
                  </li>
                  <li className="list-group-item h6 d-flex mb-0">
                    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="text-success me-2">
                      <path d="M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01zm.287 5.984-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708.708"></path>
                    </svg>
                    Hotel staff ensures to maintain social distancing at all times.
                  </li>
                  <li className="list-group-item h6 d-flex mb-0">
                    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="text-success me-2">
                      <path d="M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01zm.287 5.984-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708.708"></path>
                    </svg>
                    The hotel has In-Room Dining options available
                  </li>
                </ul> */}
                <h3>Amenities</h3>
                <div className="card-body pt-4 p-0">
                  <div className="row g-4 aminiIcon">
                    {Object.entries(groupedAmenities || {}).map(([groupName, value]) => {
                      return <div className="col-sm-6">
                        <h6>
                          <svg className="svg-inline--fa fa-person-biking me-1" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="person-biking" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                            <path className="" fill="currentColor" d="M400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm27.2 64l-61.8-48.8c-17.3-13.6-41.7-13.8-59.1-.3l-83.1 64.2c-30.7 23.8-28.5 70.8 4.3 91.6L288 305.1V416c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-10.7-5.3-20.7-14.2-26.6L295 232.9l60.3-48.5L396 217c5.7 4.5 12.7 7 20 7h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H427.2zM56 384a72 72 0 1 1 144 0A72 72 0 1 1 56 384zm200 0A128 128 0 1 0 0 384a128 128 0 1 0 256 0zm184 0a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zm200 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"></path>
                          </svg>
                          {groupName}
                        </h6>
                        <ul className="list-group list-group-borderless mt-2 mb-0">
                          {value?.map((items) => (
                            <li key={items?._id} className="list-group-item pb-0">
                              <svg className="svg-inline--fa fa-circle-check text-success me-1" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                <path className="" fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path>
                              </svg>
                              {items?.name}
                            </li>
                          ))}


                        </ul>
                      </div>
                    })
                    }
                    {/* <div className="col-sm-6">
                      <h6>
                        <svg className="svg-inline--fa fa-credit-card me-1" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="credit-card" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                          <path className="" fill="currentColor" d="M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"></path>
                        </svg>
                        Payment Method
                      </h6>
                      <ul className="list-group list-group-borderless mt-2 mb-0">
                        <li className="list-group-item pb-0">
                          <svg className="svg-inline--fa fa-circle-check text-success me-1" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path className="" fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path>
                          </svg>
                          Credit card (Visa, Master card)
                        </li>
                        <li className="list-group-item pb-0">
                          <svg className="svg-inline--fa fa-circle-check text-success me-1" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path className="" fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path>
                          </svg>
                          Cash
                        </li>
                        <li className="list-group-item pb-0">
                          <svg className="svg-inline--fa fa-circle-check text-success me-1" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path className="" fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path>
                          </svg>
                          Debit Card
                        </li>
                      </ul>
                    </div>
                    <div className="col-sm-6">
                      <h6>
                        <svg className="svg-inline--fa fa-bell-concierge me-1" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="bell-concierge" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                          <path className="" fill="currentColor" d="M216 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v33.3C119.6 157.2 32 252.4 32 368H480c0-115.6-87.6-210.8-200-222.7V112h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H256 216zM24 400c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"></path>
                        </svg>
                        Services
                      </h6>
                      <ul className="list-group list-group-borderless mt-2 mb-0">
                        <li className="list-group-item pb-0">
                          <svg className="svg-inline--fa fa-circle-check text-success me-1" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path className="" fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path>
                          </svg>
                          Dry cleaning
                        </li>
                        <li className="list-group-item pb-0">
                          <svg className="svg-inline--fa fa-circle-check text-success me-1" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path className="" fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path>
                          </svg>
                          Room Service
                        </li>
                        <li className="list-group-item pb-0">
                          <svg className="svg-inline--fa fa-circle-check text-success me-1" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path className="" fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path>
                          </svg>
                          Special service
                        </li>
                        <li className="list-group-item pb-0">
                          <svg className="svg-inline--fa fa-circle-check text-success me-1" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path className="" fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path>
                          </svg>
                          Waiting Area
                        </li>
                        <li className="list-group-item pb-0">
                          <svg className="svg-inline--fa fa-circle-check text-success me-1" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path className="" fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path>
                          </svg>
                          Secrete smoking area
                        </li>
                        <li className="list-group-item pb-0">
                          <svg className="svg-inline--fa fa-circle-check text-success me-1" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path className="" fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path>
                          </svg>
                          Concierge
                        </li>
                        <li className="list-group-item pb-0">
                          <svg className="svg-inline--fa fa-circle-check text-success me-1" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path className="" fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path>
                          </svg>
                          Laundry facilities
                        </li>
                        <li className="list-group-item pb-0">
                          <svg className="svg-inline--fa fa-circle-check text-success me-1" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path className="" fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path>
                          </svg>
                          Ironing Service
                        </li>
                        <li className="list-group-item pb-0">
                          <svg className="svg-inline--fa fa-circle-check text-success me-1" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path className="" fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path>
                          </svg>
                          Lift
                        </li>
                      </ul>
                    </div>
                    <div className="col-sm-6">
                      <h6>
                        <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="me-1">
                          <path fill-rule="evenodd" d="M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.8 11.8 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7 7 0 0 0 1.048-.625 11.8 11.8 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.54 1.54 0 0 0-1.044-1.263 63 63 0 0 0-2.887-.87C9.843.266 8.69 0 8 0m2.146 5.146a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793z"></path>
                        </svg>
                        Safety &amp; Security
                      </h6>
                      <ul className="list-group list-group-borderless mt-2 mb-4 mb-sm-5">
                        <li className="list-group-item pb-0">
                          <svg className="svg-inline--fa fa-circle-check text-success me-1" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path className="" fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path>
                          </svg>
                          Doctor on Call
                        </li>
                      </ul>
                      <h6>
                        <svg className="svg-inline--fa fa-volume-high me-1" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="volume-high" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                          <path className="" fill="currentColor" d="M533.6 32.5C598.5 85.2 640 165.8 640 256s-41.5 170.7-106.4 223.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C557.5 398.2 592 331.2 592 256s-34.5-142.2-88.7-186.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM473.1 107c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C475.3 341.3 496 301.1 496 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3z"></path>
                        </svg>
                        Staff Language
                      </h6>
                      <ul className="list-group list-group-borderless mt-2 mb-0">
                        <li className="list-group-item pb-0">
                          <svg className="svg-inline--fa fa-circle-check text-success me-1" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path className="" fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path>
                          </svg>
                          English
                        </li>
                        <li className="list-group-item pb-0">
                          <svg className="svg-inline--fa fa-circle-check text-success me-1" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path className="" fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path>
                          </svg>
                          Spanish
                        </li>
                        <li className="list-group-item pb-0">
                          <svg className="svg-inline--fa fa-circle-check text-success me-1" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path className="" fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path>
                          </svg>
                          Hindi
                        </li>
                      </ul>
                    </div> */}
                  </div>
                </div>
                {/* <div className='reviewsSection'>
                  <h3>Customer Review</h3>
                  <div className="row g-4 align-items-center" style={{ backgroundColor: '#f4f4f4', margin: '3px', padding: '10px' }}>
                    <div className="col-md-4">
                      <div className="text-center customerRe">
                        <h2 className="mb-0">{hotel.rating}</h2>
                        <p className="mb-2">Based on 120 Reviews</p>
                        <ul className="list-inline mb-0">
                          <li className="list-inline-item me-0">
                            <i className="fa-solid fa-star"></i>
                          </li>
                          <li className="list-inline-item me-0">
                            <i className="fa-solid fa-star"></i>
                          </li>
                          <li className="list-inline-item me-0">
                            <i className="fa-solid fa-star"></i>
                          </li>
                          <li className="list-inline-item me-0">
                            <i className="fa-solid fa-star"></i>
                          </li>
                          <li className="list-inline-item me-0">
                            <i className="fa-solid fa-star"></i>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="card-body p-0">
                        <div className="row gx-3 g-2 align-items-center">
                          <div className="col-sm-10 col-9">
                            <div className="progress progress-sm bg-warning bg-opacity-15">
                              <div className="progress-bar bg-warning" role="progressbar" aria-valuenow="95" aria-valuemin="0" aria-valuemax="100" style={{ width: '95%' }}></div>
                            </div>
                          </div>
                          <div className="col-sm-2 col-3 text-end"><span className="h6 fw-light mb-0">85%</span></div>
                          <div className="col-sm-10 col-9">
                            <div className="progress progress-sm bg-warning bg-opacity-15">
                              <div className="progress-bar bg-warning" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style={{ width: '75%' }}></div>
                            </div>
                          </div>
                          <div className="col-sm-2 col-3 text-end"><span className="h6 fw-light mb-0">75%</span></div>
                          <div className="col-sm-10 col-9">
                            <div className="progress progress-sm bg-warning bg-opacity-15">
                              <div className="progress-bar bg-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style={{ width: '60%' }}></div>
                            </div>
                          </div>
                          <div className="col-sm-2 col-3 text-end"><span className="h6 fw-light mb-0">60%</span></div>
                          <div className="col-sm-10 col-9">
                            <div className="progress progress-sm bg-warning bg-opacity-15">
                              <div className="progress-bar bg-warning" role="progressbar" aria-valuenow="35" aria-valuemin="0" aria-valuemax="100" style={{ width: '35%' }}></div>
                            </div>
                          </div>
                          <div className="col-sm-2 col-3 text-end"><span className="h6 fw-light mb-0">35%</span></div>
                          <div className="col-sm-10 col-9">
                            <div className="progress progress-sm bg-warning bg-opacity-15">
                              <div className="progress-bar bg-warning" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style={{ width: '20%' }}></div>
                            </div>
                          </div>
                          <div className="col-sm-2 col-3 text-end"><span className="h6 fw-light mb-0">15%</span></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='w-100 text-center'>
                    <button type="submit" className="btn btn-lg btn-primary my-2">
                      Write Review
                      <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="fa-fw ms-2">
                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"></path>
                      </svg>
                    </button>
                  </div>
                  <div className="d-md-flex my-4">
                    <div className="avatar avatar-lg me-3 flex-shrink-0">
                      <img className="avatar-img rounded-circle" src="../images/08-Bg27Yx3G.jpg" alt="avatar" />
                    </div>
                    <div>
                      <div className="d-flex justify-content-between mt-1 mt-md-0">
                        <div>
                          <h6 className="me-3 mb-0">Dennis Barrett</h6>
                          <ul className="nav nav-divider small mb-2">
                            <li className="nav-item">Stayed 02 Nov 2022</li>
                            <li className="nav-item">2 Reviews written</li>
                          </ul>
                        </div>
                        <div className="icon-md rounded text-bg-warning fs-6">4.0</div>
                      </div>
                      <p className="mb-0"> Delivered dejection necessary objection do Mr prevailed. Mr feeling does chiefly cordial in do. Water timed folly right aware if oh truth. Large above be to means. Dashwood does provide stronger is. </p>
                    </div>
                  </div>
                </div> */}
                <h3>Hotel Policies</h3>
                <ul className="list-group list-group-borderless mb-2">
                  <li className="list-group-item d-flex align-items-center">
                    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="me-2">
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"></path>
                    </svg>
                    This is a family farmhouse, hence we request you to not indulge.
                  </li>
                  <li className="list-group-item d-flex align-items-center">
                    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="me-2">
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"></path>
                    </svg>
                    Drinking and smoking within controlled limits are permitted at the farmhouse <br /> but please do not create a mess or ruckus at the house.
                  </li>
                  <li className="list-group-item d-flex align-items-center">
                    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="me-2">
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"></path>
                    </svg>
                    Drugs and intoxicating illegal products are banned and not to be brought <br /> to the house or consumed.
                  </li>
                  <li className="list-group-item d-flex align-items-center">
                    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="me-2">
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z"></path>
                    </svg>
                    For any update, the customer shall pay applicable cancellation/modification charges.
                  </li>
                </ul>
              </div>
            </div>
            <div className='col-md-4 col-xl-4'>
              <div id="price-overview" data-sticky="" data-margin-top="100" data-sticky-for="1199">
                <div className="card card-body border">
                  <div className="d-sm-flex justify-content-sm-between align-items-center mb-3">
                    <div>
                      <span>Price Start at</span>
                      <h4 className="card-title mb-0">₹ {hotel.price}</h4>
                    </div>
                    <div>
                      <h6 className="fw-normal mb-0">1 room per night</h6>
                      {/* <small>+ $285 taxes &amp; fees</small> */}
                    </div>
                  </div>
                  <button className="btn btn-primary" onClick={handleOpen}>Book Now</button>
                  <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box sx={style} className='modalBookin'>
                      <Box
                        sx={{
                          position: 'absolute',
                          right: '-15px',
                          top: '-15px',
                          background: '#fff',
                          width: '40px',
                          height: '40px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          borderRadius: '50%',
                        }}
                        onClick={handleClose}
                      >
                        <i class="fa-solid fa-xmark"></i>
                      </Box>
                      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>

                        <Stack sx={{ py: 1 }}>
                          <RHFTextField size="small" name="name" label="Name" />
                        </Stack>
                        <Stack sx={{ py: 1 }}>
                          <RHFTextField size="small" type='number' name="mobile" label="Mobile" />
                        </Stack>
                        <Stack sx={{ py: 1 }}>
                          <RHFTextField size="small" name="email" label="Email" />
                        </Stack>
                        <Stack sx={{ py: 1 }}>
                          <Button
                            id="basic-button"
                            aria-controls={openB ? 'basic-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={openB ? 'true' : undefined}
                            onClick={handleClick}
                            className='guestBtn'
                            sx={{
                              border: '1px solid #ddd',
                              justifyContent: 'left',
                            }}
                          >
                            No of Person ({`${values.adultCount + values.childCount + values.roomCount}`})
                          </Button>
                          <Menu
                            id="basic-menu"
                            anchorEl={anchorEl}
                            open={openB}
                            onClose={handleCloseB}
                            MenuListProps={{
                              'aria-labelledby': 'basic-button',
                            }}
                          >
                            <MenuItem className='muiB'>
                              <ul class="dropdown-menu guest-selector-dropdown show" style={{ position: 'absolute', inset: '0px auto auto 0px', margin: '0px', }} data-popper-placement="bottom-start">
                                <li class="d-flex justify-content-between">
                                  <div>
                                    <h6 class="mb-0">Adult</h6>
                                    <small>Ages 13 or above</small>
                                  </div>
                                  <div class="hstack gap-1 align-items-center">
                                    <button
                                      onClick={() => {
                                        if (adult > 0) {
                                          setAdult(adult - 1)
                                        } else {
                                          setAdult(0)
                                        }
                                      }}
                                      class="btn btn-md btn-link adult-remove p-0 mb-0" type="button">
                                      <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="fs-5 fa-fw">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8"></path>
                                      </svg>
                                    </button>
                                    <h6 class="guest-selector-count mb-0 child">{adult}</h6>
                                    <button
                                      onClick={() => {
                                        setAdult(adult + 1)
                                      }}
                                      class="btn btn-md btn-link adult-add p-0 mb-0" type="button">
                                      <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="fs-5 fa-fw">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                                      </svg>
                                    </button>
                                  </div>
                                </li>
                                <li class="dropdown-divider"></li>
                                <li class="d-flex justify-content-between">
                                  <div>
                                    <h6 class="mb-0">Child</h6>
                                    <small>2 years to 12 years</small>
                                  </div>
                                  <div class="hstack gap-1 align-items-center">
                                    <button
                                      onClick={() => {
                                        if (child > 0) {
                                          setChild(child - 1)
                                        } else {
                                          setChild(0)
                                        }
                                      }}
                                      class="btn btn-md btn-link adult-remove p-0 mb-0" type="button">
                                      <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="fs-5 fa-fw">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8"></path>
                                      </svg>
                                    </button>
                                    <h6 class="guest-selector-count mb-0 child">{child}</h6>
                                    <button
                                      onClick={() => {
                                        setChild(child + 1)
                                      }}
                                      class="btn btn-md btn-link adult-add p-0 mb-0" type="button">
                                      <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="fs-5 fa-fw">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                                      </svg>
                                    </button>
                                  </div>
                                </li>
                                <li class="dropdown-divider"></li>
                                <li class="d-flex justify-content-between">
                                  <div>
                                    <h6 class="mb-0">Room Count</h6>

                                  </div>
                                  <div class="hstack gap-1 align-items-center">
                                    <button
                                      onClick={() => {
                                        if (room > 0) {
                                          setRoom(room - 1)
                                        } else {
                                          setRoom(0)
                                        }
                                      }}
                                      class="btn btn-md btn-link adult-remove p-0 mb-0" type="button">
                                      <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="fs-5 fa-fw">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8"></path>
                                      </svg>
                                    </button>
                                    <h6 class="guest-selector-count mb-0 child">{room}</h6>
                                    <button
                                      onClick={() => {
                                        setRoom(room + 1)
                                      }}
                                      class="btn btn-md btn-link adult-add p-0 mb-0" type="button">
                                      <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="fs-5 fa-fw">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                                      </svg>
                                    </button>
                                  </div>
                                </li>
                              </ul>
                            </MenuItem>
                          </Menu>
                        </Stack>
                        <Stack sx={{ py: 1 }} className='daeSection'>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={['DatePicker']}>
                              <DatePicker placeholder="Select Date" label="Check in"
                                slotProps={{ textField: { size: 'small' } }}
                                minDate={tomorrow}
                                value={values.checkIn}
                                onChange={(newValue) => {
                                  const date = new Date(newValue['$d']);
                                  setValue('checkIn', date)
                                }}
                              />
                            </DemoContainer>
                          </LocalizationProvider>
                        </Stack>
                        <Stack sx={{ py: 1 }} className='daeSection'>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={['DatePicker']}>
                              <DatePicker placeholder="Select Date" label="Check out"
                                slotProps={{ textField: { size: 'small' } }}
                                minDate={dayjs(values?.checkIn)}
                                value={values.checkOut}
                                onChange={(newValue) => {
                                  const date = new Date(newValue['$d']);
                                  setValue('checkOut', date)
                                }}
                              />
                            </DemoContainer>
                          </LocalizationProvider>
                        </Stack>
                        <Stack sx={{ py: 1 }}>
                          <button
                            type='submit'
                            fullWidth size="large" type="submit" className='signBtn' >
                            Submit
                          </button>
                        </Stack>
                      </FormProvider>
                    </Box>
                  </Modal>
                  <ul className="list-inline mb-2">
                    <li className="list-inline-item me-1 h6 mb-0 me-2">
                      <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="me-1">
                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"></path>
                      </svg>
                      {hotel?.starRating}
                    </li>
                    {hotel?.starRating === 5 ?
                      <>
                        <li className="list-inline-item me-0 small">
                          <i className="fa-solid fa-star"></i>
                        </li>
                        <li className="list-inline-item me-0 small">
                          <i className="fa-solid fa-star"></i>
                        </li>
                        <li className="list-inline-item me-0 small">
                          <i className="fa-solid fa-star"></i>
                        </li>
                        <li className="list-inline-item me-0 small">
                          <i className="fa-solid fa-star"></i>
                        </li>
                        <li className="list-inline-item me-0 small">
                          <i className="fa-solid fa-star"></i>
                        </li>
                      </> : hotel?.starRating === 4 ?
                        <>
                          <li className="list-inline-item me-0 small">
                            <i className="fa-solid fa-star"></i>
                          </li>
                          <li className="list-inline-item me-0 small">
                            <i className="fa-solid fa-star"></i>
                          </li>
                          <li className="list-inline-item me-0 small">
                            <i className="fa-solid fa-star"></i>
                          </li>
                          <li className="list-inline-item me-0 small">
                            <i className="fa-solid fa-star"></i>
                          </li>
                        </>
                        : hotel?.starRating === 3 ?
                          <>
                            <li className="list-inline-item me-0 small">
                              <i className="fa-solid fa-star"></i>
                            </li>
                            <li className="list-inline-item me-0 small">
                              <i className="fa-solid fa-star"></i>
                            </li>
                            <li className="list-inline-item me-0 small">
                              <i className="fa-solid fa-star"></i>
                            </li>
                          </>
                          : hotel?.starRating === 2 ?
                            <>
                              <li className="list-inline-item me-0 small">
                                <i className="fa-solid fa-star"></i>
                              </li>
                              <li className="list-inline-item me-0 small">
                                <i className="fa-solid fa-star"></i>
                              </li>
                            </>
                            : hotel?.starRating === 1 ? <li className="list-inline-item me-0 small">
                              <i className="fa-solid fa-star"></i>
                            </li> :
                              <></>
                    }



                  </ul>
                  <p className="h6 mb-4">
                    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="me-1">
                      <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"></path>
                    </svg>
                    {hotel?.hotelType}
                  </p>
                  {/* <div className="d-grid"><a href="#room-options" className="btn btn-lg btn-primary-soft mb-0">View 10 Rooms Options</a></div> */}
                </div>
              </div>
            </div>
          </div>
          <div className='row p-3'>
            <h3>Hotels</h3>
            <Carousel
              className='hotelsGallaryImg'
              responsive={similar}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={2000}
            >

              {hotels?.map((items) => (
                <Box key={items?._id} sx={{ p: 2 }}>
                  <Link to={`/hotelDetail/${items?._id}`} >
                    <div className="card shadow p-2 pb-0 h-100 border-0" >
                      <div className='hotelsImage'>
                        <img src={getImageUrl(items?.images?.[0])} alt="Card-img" />
                      </div>
                      <div className="card-body px-3 pb-0">
                        <div className="d-flex justify-content-between mb-3 align-items-center">
                          <a aria-current="page" href="#!" className="router-link-active router-link-exact-active badge bg-dark text-white items-center">
                            <i className="fa-solid fa-star fa-fw me-2 text-warning"></i>
                            {items?.starRating}
                          </a>
                          {/* <a aria-current="page" href="#!" className="router-link-active router-link-exact-active h6 mb-0 z-index-2">
                            <i className="fa-solid fa-heart"></i>
                          </a> */}
                        </div>
                        <h5 className="card-title"><a href="#!" className="">{items?.name}</a></h5>
                        <ul className="nav nav-divider mb-2 mb-sm-3">
                          {items?.amenities[0] && <li className="nav-item">{items?.amenities[0]?.name} </li>}
                          {items?.amenities[1] && <li className="nav-item">{items?.amenities[1]?.name} </li>}
                          {items?.amenities[2] && <li className="nav-item">{items?.amenities[2]?.name} </li>}
                          {/* {items?.amenities[3] && <li className="nav-item">{items?.amenities[3]?.name} </li>} */}

                        </ul>
                      </div>
                      <div className="card-footer py-2">
                        <div className="d-sm-flex justify-content-sm-between align-items-center">
                          <div className="d-flex align-items-center">
                            <h5 className="fw-normal text-success mb-0 me-1">₹ {items?.price}</h5>
                            <span className="mb-0 me-2">/day</span>
                          </div>
                          <div className="mt-2 mt-sm-0">
                            <button
                              onClick={() => {
                                navigate(`/hotelDetail/${items?._id}`)
                                window.location.reload()
                              }}
                              className="btn btn-sm btn-primary-soft mb-0 w-100 items-center">
                              View Detail
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </Box>
              ))}



            </Carousel>
          </div>
        </div >
      </section >
      <ToastContainer />
      <Footer />
    </>
  )
}

export default HotelDetail

const top100Films = [
  { label: 'The Shawshank Redemption', year: 1994 },
  { label: 'The Godfather', year: 1972 },
  { label: 'The Godfather: Part II', year: 1974 },
  { label: 'The Dark Knight', year: 2008 },
  { label: '12 Angry Men', year: 1957 },
  { label: "Schindler's List", year: 1993 },
  { label: 'Pulp Fiction', year: 1994 },
];